export const SELECTION_VALUES = {
  dtc: 'dtc',
  components: 'components',
  pinout: 'pinout',
  repairHistory: 'repair-history',
  switchTest: 'switch-test',
}
